import { SVG, IconProps } from "../SVG";
import React from "react";

export const FunctionalSplit = ({ color = "#3667E9", strokeWidth = 2, ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M15 3h5m0 0v5m0-5-6.52 6.927A5 5 0 0 1 9.84 11.5H3.5M20 15v5m0 0h-5m5 0-6-6"
        />
    </SVG>
);
FunctionalSplit.displayName = "FunctionalSplit";
